var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_193_1238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0249 22.0227L18.0187 16.0165L24.0249 10.0103C24.5777 9.45748 24.5777 8.56112 24.0249 8.00827C23.472 7.45542 22.5757 7.45542 22.0228 8.00827L16.0166 14.0145L10.0104 8.00827C9.45755 7.45542 8.56119 7.45542 8.00833 8.00827C7.45548 8.56112 7.45548 9.45748 8.00833 10.0103L14.0145 16.0165L8.00833 22.0227C7.45548 22.5756 7.45548 23.472 8.00833 24.0248C8.56119 24.5777 9.45755 24.5777 10.0104 24.0248L16.0166 18.0186L22.0228 24.0248C22.5757 24.5777 23.472 24.5777 24.0249 24.0248C24.5777 23.472 24.5777 22.5756 24.0249 22.0227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_193_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6508,
    height: 22.6508,
    fill: "white",
    transform: "translate(16.0166) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.369105fa59b73234c9b2d7db9bea9c6c.svg";
export { ForwardRef as ReactComponent };